import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import he from "./locales/he.json";

export const SUPPORTED_LANGUAGES = ["en", "he"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export function isRtlLanguage(lang: string): boolean {
  return i18next.dir(lang) === "rtl";
}

export function applyDocumentLanguage(lang: string) {
  document.documentElement.lang = lang.split("-")[0];
  document.documentElement.dir = i18next.dir(lang);
}

i18next.use(LanguageDetector).use(initReactI18next).init(
  {
    resources: {
      en: { translation: en },
      he: { translation: he },
    },
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "shanirarts-lang",
    },
  },
  () => {
    applyDocumentLanguage(i18next.language || "en");
  },
);

i18next.on("languageChanged", (lng) => applyDocumentLanguage(lng));

export default i18next;
